type ErrorType =
    | 'CircleRsvpSuccessful'
    | 'CircleNotFoundError'
    | 'CircleValidationError'
    | 'CircleProcessingError'
    | 'CircleSessionSeatLimitExceededError'
    | 'CirclePermissionDeniedError'
    | 'CircleRsvpForSessionExistsForUserError'
    | 'CircleSessionAlreadyStartedError'
    | 'CircleSeriesAccessTypeNotAllowedError';

export const getErrorMessage = (type?: ErrorType | undefined): string => {
    // Values are translation keys that need to be passed to the translation function
    // Ex: t(getErrorMessage(errorType))
    const defaultErrorMessage = 'circles:registration_errors.default';
    if (!type) return defaultErrorMessage;
    const messagesDict: Record<string, string> = {
        CircleSessionAlreadyStartedError: 'circles:registration_errors.session_already_started',
        CircleSessionSeatLimitExceededError:
            'circles:registration_errors.session_seat_limit_exceeded',
        CircleRsvpForSessionExistsForUserError:
            'circles:registration_errors.session_already_exists_for_user',
    };
    return messagesDict[type] ?? defaultErrorMessage;
};
